import request from '@/utils/request'

/**
 * 查询商城订单列表（平台管理后台，订单维度）
 * @param {Object} params 查询参数
 * @returns {Promise} Promise对象
 */
export function queryStoreOrder(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/storeOrder.queryStoreOrder',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 查询管理员店铺列表
 * @param {Object} params 查询参数
 * @returns {Promise} Promise对象
 */
export function queryShopsByAdmin(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/shop.queryShopsByAdmin',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

/**
 * 导出商城订单
 * @param {Object} params 导出参数
 * @returns {Promise} Promise对象
 */
export function exportData(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/export.exportData',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}
